module.exports = function() {
  return new Worker(__webpack_public_path__ + "aac7357810c5abd0584e.worker.js");
};